<template>
  <div class="flex flex_center drackDeviceMark">
    <el-popover
      placement="top-start"
      :disabled="!markConfig.showPopover"
      :title="''"
      width="200"
      trigger="click"
    >
      <!-- hover -->
      <div>
        <div class="head">
          <div>
            {{ colDef.headerName }}
          </div>
          <span class="gray_light_color"> {{ rowData["shipmentUnitId"] }}</span>
        </div>
        <div class="flex observed_box gray_light_color">
          <span class="gray_light_color observed_label"
            >{{ $t("trackPay.trackDeviceMark.observed") }}:</span
          >
          <div class="flex_1">
            <div class="flex flex_between">
              <span>{{ $t("seller.sell.SellModal.min") }} :</span>
              <span>0{{ markConfig.unit }}</span>
            </div>
            <div class="flex flex_between">
              <span>{{ $t("seller.sell.SellModal.max") }} :</span>
              <span>0.89{{ markConfig.unit }}</span>
            </div>
          </div>
        </div>
        <div class="device_slider">
          <el-slider disabled v-model="value" :max="max" :min="min" range :marks="marks">
          </el-slider>
        </div>
      </div>
      <div
        slot="reference"
        :class="`device_status device_status_${isHas ? 'isHas' : ''}`"
      ></div>
    </el-popover>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: [10, 15],
    };
  },
  computed: {
    isHas() {
      const { colDef, data } = this.params;
      let isHas = false;
      if (data[colDef.field]) {
        isHas = true;
      }
      return isHas;
    },
    colDef() {
      return this.params.colDef;
    },
    rowData() {
      return this.params.data;
    },
    markConfig() {
      return this.params.markConfig;
    },
    max() {
      let value = 0;
      if (this.markConfig.showPopover) {
        const { min, max, unit } = this.markConfig;
        value = max;
      }
      return value;
    },
    min() {
      let value = 0;
      if (this.markConfig.showPopover) {
        const { min, max, unit } = this.markConfig;
        value = min;
      }
      return value;
    },
    marks() {
      let list = {};
      if (this.markConfig.showPopover) {
        const { min, max, unit } = this.markConfig;
        list[min] = String(min) + unit;
        list[max] = String(max) + unit;
      }
      return list;
    },
  },
};
</script>
<style lang="scss">
.drackDeviceMark {
  margin: auto;
}
.device_status {
  width: 16px;
  height: 16px;
  background-color: rgba($color: #58b71d, $alpha: 0.6);
  display: inline-block;
  text-align: center;
  font-weight: bold;
  border-radius: 50%;
  margin: auto;
  &.device_status_isHas {
    background-color: rgba($color: #58b71d, $alpha: 1);
  }
}
.observed_box {
  margin-top: 20px;
  .observed_label {
    margin-right: 15px;
  }
}
.device_slider {
  padding: 10px 15px;
  .el-slider__bar {
    background-color: rgba($color: #bce2a4, $alpha: 1) !important;
    top: -5px;
    z-index: 1;
    height: 10px;
  }
  .el-slider__button-wrapper {
    display: none;
  }
  .el-slider__runway {
    height: 1px;
    background-color: #333;
  }
  .el-slider__marks-stop {
    border: 1px solid #333;
    border-radius: 0;
    height: 20px;
    width: 1px;
    top: -10px;
  }
  .el-slider__marks-text {
    font-size: 12px;
  }
}
</style>
